(() => {
  const script = document.querySelector('script[src*="wishlist.js"]');
  const key = 'azha:wishlist:v1';
  const maxItems = 128;
  const root = script.dataset.rootUrl;
  const error = document.querySelector('[data-wishlist-error]');
  const page = document.querySelector('[data-wishlist-page]');

  function showError(message) {
    error.textContent = message;
    error.hidden = false;
  }

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(value)) return [];
      const ids = new Set();
      return value.filter(item => {
        if (!item || !item.id || !item.handle || ids.has(String(item.id))) return false;
        ids.add(String(item.id));
        return true;
      }).slice(0, maxItems);
    } catch {
      showError(script.dataset.storageError);
      return [];
    }
  }

  function save(items) {
    try {
      localStorage.setItem(key, JSON.stringify(items));
      error.hidden = true;
      return true;
    } catch {
      showError(script.dataset.storageError);
      return false;
    }
  }

  function syncButtons(items = read()) {
    const ids = new Set(items.map(item => String(item.id)));
    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      const saved = ids.has(button.dataset.productId);
      button.dataset.saved = String(saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.removeLabel : button.dataset.addLabel);
    });
  }

  function renderPage() {
    if (!page) return;
    const items = read();
    const empty = page.querySelector('[data-wishlist-empty]');
    const grid = page.querySelector('[data-wishlist-grid]');
    grid.replaceChildren();
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    if (!items.length) return;

    Promise.all(items.map(async item => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(item.handle)}?section_id=wishlist-product-card`);
        if (response.status === 404) return null;
        if (!response.ok) return false;
        const html = await response.text();
        const product = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-wishlist-product-id]');
        if (!product) return false;
        return product.dataset.wishlistProductId === String(item.id) ? product : null;
      } catch {
        return false;
      }
    })).then(products => {
      if (JSON.stringify(read()) !== JSON.stringify(items)) return renderPage();
      items.forEach((item, index) => {
        const product = products[index];
        const card = document.createElement('article');
        card.className = 'flex flex-col gap-2';
        if (product) {
          card.append(product);
        } else {
          const detail = document.createElement('p');
          detail.className = 'text-sm text-foreground/70';
          detail.textContent = `${item.handle} — ${product === false ? script.dataset.loadError : script.dataset.removed}`;
          card.append(detail);
        }
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'self-start text-sm text-primary underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary';
        remove.dataset.wishlistRemove = String(item.id);
        remove.textContent = script.dataset.remove;
        card.append(remove);
        grid.append(card);
      });
      syncButtons(items);
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wishlist-button]');
    const remove = event.target.closest('[data-wishlist-remove]');
    if (!button && !remove) return;
    const items = read();
    const id = button ? button.dataset.productId : remove.dataset.wishlistRemove;
    const index = items.findIndex(item => String(item.id) === id);
    if (index !== -1) items.splice(index, 1);
    else if (button) {
      if (items.length >= maxItems) return showError(script.dataset.limitError);
      items.push({ id, handle: button.dataset.productHandle });
    }
    if (save(items)) {
      syncButtons(items);
      renderPage();
    }
  });

  window.addEventListener('storage', event => {
    if (event.key === key) {
      syncButtons();
      renderPage();
    }
  });
  const searchDrawer = document.querySelector('search-drawer');
  if (searchDrawer) {
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-wishlist-button]') || node.querySelector('[data-wishlist-button]'))))) {
        syncButtons();
      }
    }).observe(searchDrawer, { childList: true, subtree: true });
  }
  syncButtons();
  renderPage();
})();
